<div class="business-navbar__modal__content" [ngStyle]="{'width': widthStyle, 'max-height': maxHeightStyle, 'height': heightStyle}" [ngClass]="{'business-navbar__modal__content--mobile': (isMobile$ | async)}">
    <ng-content></ng-content>
</div>
